import { takeEvery } from 'redux-saga/effects'
import {submitFormDownloadApiWsdlRoutine} from './api_routines'
import {submitDownloadApiWsdlForm} from './api_download_wsdl_saga'

const apiSagas = [
  takeEvery(submitFormDownloadApiWsdlRoutine.TRIGGER, submitDownloadApiWsdlForm)
]

export default apiSagas
